import React from 'react';
import { format, parse } from 'date-fns';
import { Card, CardContent, CardTitle } from '@/ui/components/card';
import type { Company } from '../../models/companies/company';
import { numberToCurrency } from '../../../common/utils/commonUtil';
import AmountYenSvg from '../../assets/images/views/companies/amount_yen.svg';
import InvestorSvg from '../../assets/images/views/companies/investor.svg';

interface Props {
  company: Company;
}

export function CompanyCard({ company }: Props) {
  return (
    // リボンを重ねるため relative にする。画像は Card の第一子に置く
    // （Card 側が has-[>img:first-child] で上の余白を落とすため、順序を変えない）。
    <Card variant="borderless" className="tw:relative tw:h-full">
      {/* Figma では画像の四隅が丸い（10px）。DS の値に寄せて最大トークンの rounded-lg にする */}
      <img
        src={company.thumbUrl}
        alt={company.name}
        className="tw:w-full tw:rounded-lg"
      />
      {/* 左上は画像の角丸に沿わせ、右下は Card と同じ半径にする
          （レガシー CSS からは DS トークンを参照できない） */}
      <div className="ribbon tw:rounded-tl-lg tw:rounded-br-md">
        <span className="mr-1">最終調達</span>
        {format(
          parse(company.lastFinanceOn, 'yyyy-MM-dd', new Date()),
          'yyyy年MM月dd日',
        )}
      </div>
      <CardContent>
        {/* 一覧の見出しは h1（調達企業一覧）なので、カード名は h2 にする */}
        <CardTitle as="h2">{company.name}</CardTitle>
        <div className="tw:mt-0.5">
          <span className="mr-3">
            <img src={InvestorSvg} width="13" className="svg-icon" />
            {company.investorsSize}人
          </span>
          <span>
            <img src={AmountYenSvg} width="13" className="svg-icon" />
            {numberToCurrency(company.totalFinance)}
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
